import { render, staticRenderFns } from "./AppHeaderNavMoreLocalItem.vue?vue&type=template&id=28c93a94&"
import script from "./AppHeaderNavMoreLocalItem.vue?vue&type=script&lang=js&"
export * from "./AppHeaderNavMoreLocalItem.vue?vue&type=script&lang=js&"
import style0 from "./AppHeaderNavMoreLocalItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports